<template>
  <div id="translations">
    <div class="container">

      <Panel :title="$t('translations.panel_title')">

        <div class="text" v-html="$t('translations.description')"></div>
        <br>

        <Panel :title="$t('translations.languages')" collapsible>
          <div class="text">{{$t('translations.branch_languages')}}:</div>
          <div class="languages">
            <div class="group">
              <input id="chk_en" type="checkbox" v-model="en">
              <label for="chk_en">EN</label>
            </div>
            <div class="group">
              <input id="chk_fr" type="checkbox" v-model="fr">
              <label for="chk_fr">FR</label>
            </div>
          </div>
        </Panel>

        <Panel :title="$t('translations.rules')" collapsible>

          <div class="title">
            <div class="text">{{$t('translations.none')}}</div>
            <button class="btn btn-primary" @click="addRule">{{$t('translations.new_rule')}}</button>
          </div>

          <div class="rules">
            <div class="rule" v-for="(rule, ruleIndex) of rules">
              <div class="group">
                <label>
                  <div class="locale">
                    <svgicon src="icon/key.svg" :height="10" :width="10"></svgicon>
                  </div>
                  {{$t('translations.key')}}
                </label>
                <input type="text" v-model="rule.key">
              </div>
              <div class="group" v-for="language of languages">
                <label>
                  <div class="locale">{{language.toUpperCase()}}</div>
                  {{$t('translations.text')}}
                </label>
                <input type="text" v-model="rule.text[language]">
              </div>
              <button class="remove btn btn-primary" @click="removeRule(ruleIndex)">
                <svgicon src="icon/close.svg" :height="16" :width="16"></svgicon>
              </button>
            </div>
          </div>

        </Panel>

        <div class="buttons">
          <button class="btn btn-primary" @click="save()">{{$t('save')}}</button>
        </div>

      </Panel>

    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";

  export default {
    name: "Translations",

    data() {
      return {
        fr: true,
        en: true,
        rules: []
      }
    },

    mounted() {
      if (!this.$store.getters.loggedUserHasSuperAdmin) {
        this.$router.push("/login");
        return;
      }

      this.$store.state.pageTitleTranslationKey = "translations.title";
      this.$store.state.pageIcon = "icon/translation.svg";

      this.buildRules();
    },

    computed: {
      branch() {
        return this.$store.state.contextBranch;
      },
      languages() {
        let languages = [];
        if (this.fr) { languages.push("fr"); }
        if (this.en) { languages.push("en"); }
        return languages;
      }
    },

    methods: {

      ...mapActions([
        "saveBranch",
      ]),

      addRule() {
        this.rules.push({
          key: "",
          text: {}
        });
      },
      removeRule(index) {
        this.rules.splice(index, 1);
      },
      getFormattedRules() {
        let formattedRules = {};
        for (let language of this.languages) {
          for (let rule of this.rules) {
            if (!formattedRules[language]) {
              formattedRules[language] = {};
            }
            formattedRules[language][rule.key] = rule.text[language];
          }
        }
        return formattedRules;
      },

      buildRules() {
        if (!this.branch || !this.branch.customLocales || this.branch.customLocales.length === 0) {
          return;
        }

        this.fr = !!(this.branch.customLocales.fr && Array.isArray(this.branch.customLocales.fr) ? this.branch.customLocales.fr.length > 0: true);
        this.en = !!(this.branch.customLocales.en && Array.isArray(this.branch.customLocales.en) ? this.branch.customLocales.en.length > 0: true);

        if (this.fr || this.en) { //either language is defined
          let translationKeys = [];
          for (let language of this.languages) {
            translationKeys = translationKeys.concat([...Object.keys(this.branch.customLocales[language])]);
          }
          let uniqueTranslationKeys = [... new Set(translationKeys)];
          for (let translationKey of uniqueTranslationKeys) {
            this.rules.push({
              key: translationKey,
              text: {
                fr: this.fr ? this.branch.customLocales.fr[translationKey] : undefined,
                en: this.en ? this.branch.customLocales.en[translationKey] : undefined
              }
            })
          }
        }
      },

      async save() {
        this.$store.commit('showSpinner', true);
        let rules = this.getFormattedRules();
        console.log("rules", rules);
        let response = await this.saveBranch({
          branchId: this.branch.id,
          data: {
            customLocales: rules
          }
        });
        this.$store.commit('showSpinner', false);
        if (response) {
          toast(this.$t("branch.success"), "success");
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .text {
    color: #808080;
    font-size: 14px;
  }
  .languages {
    display: flex;
    margin-top: 10px;
    label {
      margin-right: 10px;
    }
  }
  .panel:not(:last-child) {
    margin-bottom: 0;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px dashed #d9d9d9;
  }
  .rule {
    display: flex;
    align-items: center;
    padding: 10px 0;

    &:not(:last-child) {
      border-bottom: 1px dashed #d9d9d9;
    }

    .group {
      flex-grow: 1;

      label {
        justify-content: flex-start;
      }
    }
    .group:not(:last-child) {
      margin-right: 10px;
    }
  }

  .locale {
    background-color: #a7a7a7;
    margin-right: 8px;
    border-radius: 2px;
    color: white;
    fill: white;
    font-size: 11px;
    height: 16px;
    width: 22px;
    line-height: 1;
    font-weight: bold;
    padding: 2px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .remove {
    fill: white;
    padding: 10px;
    height: 42px;
    margin-top: 10px;
  }

  .buttons {
    margin-top: 30px;
  }
</style>